/** The Tree replacements tab body. The tab is always present, so it draws its own
 *  empty state; "Add replacement" lives in the card header next to Check in. */
import { Sprout } from 'lucide-react';

import type { WorkshopTreeReplacement } from '../../../../api/workshops';
import { EmptyState } from '../../primitives/EmptyState';

import { TREE_REPLACEMENT_COLUMNS_MIN_WIDTH } from './tree-replacement-styles';
import { TreeReplacementRow } from './TreeReplacementRow';
import { TreeReplacementsListHeader } from './TreeReplacementsListHeader';
import { useNarrowContainer } from './use-narrow-container';

export interface TreeReplacementsListProps {
  workshopId: string;
  pickups: WorkshopTreeReplacement[];
  canManage: boolean;
  /** Shows pickup times in the venue's zone; without it only who picked up shows. */
  venueTimeZone?: string | null;
}

export function TreeReplacementsList({
  workshopId,
  pickups,
  canManage,
  venueTimeZone = null,
}: TreeReplacementsListProps) {
  const [ref, narrow] = useNarrowContainer<HTMLDivElement>(TREE_REPLACEMENT_COLUMNS_MIN_WIDTH);
  const layout = narrow ? 'stacked' : 'columns';
  return (
    <div ref={ref} style={{ display: 'flex', flexDirection: 'column' }}>
      {pickups.length > 0 && layout === 'columns' && <TreeReplacementsListHeader />}
      {pickups.length === 0 ? (
        <EmptyState
          icon={Sprout}
          title="No tree replacements yet"
          hint={
            canManage
              ? 'Add one when a customer is coming to collect a replacement tree.'
              : undefined
          }
        />
      ) : (
        pickups.map((p) => (
          <TreeReplacementRow
            key={p.id}
            pickup={p}
            workshopId={workshopId}
            canManage={canManage}
            venueTimeZone={venueTimeZone}
            layout={layout}
          />
        ))
      )}
    </div>
  );
}
